export default "__VITE_ASSET__CngR6__J__"